module.exports = __webpack_public_path__ + "img/Reaction.6dfd05ec.png";